import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import styles from './ImageLightbox.module.css';

interface ImageLightboxProps {
    src: string;
    alt: string;
    onClose: () => void;
}

/** Imagem em tela cheia. Um clique na imagem alterna entre caber na tela e o tamanho original. */
export function ImageLightbox({ src, alt, onClose }: ImageLightboxProps) {
    const [canEnlarge, setCanEnlarge] = useState(false);
    const [enlarged, setEnlarged] = useState(false);

    useEffect(() => {
        // Na captura: o Esc fecha so a imagem, sem chegar ao Modal que esta por baixo.
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key !== 'Escape') return;
            e.stopPropagation();
            onClose();
        };
        window.addEventListener('keydown', handleEscape, true);
        return () => window.removeEventListener('keydown', handleEscape, true);
    }, [onClose]);

    const imageClass = !canEnlarge ? styles.image : `${styles.image} ${enlarged ? styles.enlarged : styles.fitted}`;

    return createPortal(
        <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Imagem ampliada" onClick={onClose}>
            <button type="button" className={styles.closeBtn} aria-label="Fechar imagem" onClick={onClose}>
                <FiX size={22} />
            </button>
            <img
                className={imageClass}
                src={src}
                alt={alt}
                onLoad={(e) => {
                    const image = e.currentTarget;
                    setCanEnlarge(image.naturalWidth > image.clientWidth || image.naturalHeight > image.clientHeight);
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    if (canEnlarge) setEnlarged((current) => !current);
                }}
            />
        </div>,
        document.body,
    );
}
